module.exports = __webpack_public_path__ + "img/civil.3abc9c24.png";